module.exports = __webpack_public_path__ + "img/note-down-shadow.5b4167b4.png";